import styled from '@emotion/styled';
import { Divider, Image, Typography } from '@mgmresorts/mgm-ui';

export const StyledDivider = styled(Divider)`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXl}px;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const StyledBannerImage = styled(Image)`
  width: 100%;
  border-top-left-radius: ${({ theme }) => theme.semantic.BorderRadiusComponentM}px;
  border-top-right-radius: ${({ theme }) => theme.semantic.BorderRadiusComponentM}px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
  height: 172px;
`;

export const StyledBannerContent = styled.div`
  padding-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  padding-right: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  padding-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  padding-left: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  text-align: left;
  border-radius: ${({ theme }) => theme.semantic.BorderRadiusComponentM}px;
  background: ${({ theme }) => theme.semantic.InteractionSecondary};
`;

export const StyledBannerTitle = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

export const StyledIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const StyledBannerDescription = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
`;

export const StyledBannerRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.semantic.SpaceComponentS}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentS}px;

  &:last-child {
    margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentNone}px;
  }
`;
